import { render, staticRenderFns } from "./Show2.vue?vue&type=template&id=3e0eef70&scoped=true"
import script from "./Show2.vue?vue&type=script&lang=js"
export * from "./Show2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0eef70",
  null
  
)

export default component.exports